export const data = [
   {
      title: 'Aesops',
      url: 'https://aesops.co.ke',
      className: 'bg1',
      description: 'something about aesops',
   },

   {
      title: 'Kenyan Data-online',
      url: 'http://kenyandataonline.herokuapp.com',
      className: 'bg2',
      description: 'something about KDO',
   },

   {
      title: 'Google Home Mini',
      url: 'https://google-home-mini.netlify.app',
      className: 'bg1',
      description: 'something about google home mini',
   },
   {
      title: 'React Step Form',
      url: 'https://react-step-form.netlify.app',
      className: 'bg2',
      description: 'something about step form',
   },
   {
      title: 'Vacay Offers',
      url: 'http://offers.vacay.co.ke',
      className: 'bg2',
      description: 'something about offers',
   },
   {
      title: 'Essential Oils Kenya',
      url: 'http://essentialoilskenya.co.ke',
      className: 'bg1',
      description: 'something about essntial oils',
   },
   {
      title: 'Todo',
      url: 'https://todo-easypeasy.netlify.app',
      className: 'bg2',
      description: 'something about step form',
   },
   {
      title: 'Private Equity Support',
      url: 'https://www.privateequity-support.com/',
      className: 'bg2',
      description: 'something private-equity support',
   },
]
